import type { Agent } from './agent';
import type { RunContext } from './run-context';
import type { Tool } from './tool';
import type { UnknownContext } from './types';

/**
 * Interface for MCP server implementations.
 * Provides methods for connecting, listing tools, calling tools, and cleanup.
 */
export type MCPServer = {};

/**
 * Function signature for generating the MCP tool cache key.
 * Customizable so the cache key can depend on any context—server, agent, runContext, etc.
 */
export type MCPToolCacheKeyGenerator = (params: {
  server: MCPServer;
  agent?: Agent<any, any>;
  runContext?: RunContext<any>;
}) => string;

export type GetAllMcpToolsOptions<TContext> = {
  mcpServers: MCPServer[];
  convertSchemasToStrict?: boolean;
  runContext?: RunContext<TContext>;
  agent?: Agent<TContext, any>;
  generateMCPToolCacheKey?: MCPToolCacheKeyGenerator;
};

/**
 * Returns all MCP tools from the provided servers, using the function tool conversion.
 * If runContext and agent are provided, callable tool filters will be applied.
 */
export async function getAllMcpTools<TContext = UnknownContext>(
  _mcpServersOrOpts: MCPServer[] | GetAllMcpToolsOptions<TContext>,
  _runContext?: RunContext<TContext>,
  _agent?: Agent<TContext, any>,
  _convertSchemasToStrict = false,
): Promise<Tool<TContext>[]> {
  return [];
  // const opts = Array.isArray(mcpServersOrOpts)
  //   ? {
  //       mcpServers: mcpServersOrOpts,
  //       runContext,
  //       agent,
  //       convertSchemasToStrict,
  //     }
  //   : mcpServersOrOpts;
  //
  // const {
  //   mcpServers,
  //   convertSchemasToStrict: convertSchemasToStrictFromOpts = false,
  //   runContext: runContextFromOpts,
  //   agent: agentFromOpts,
  //   generateMCPToolCacheKey,
  // } = opts;
  // const allTools: Tool<TContext>[] = [];
  // const toolNames = new Set<string>();
  //
  // for (const server of mcpServers) {
  //   const serverTools = await getFunctionToolsFromServer({
  //     server,
  //     convertSchemasToStrict: convertSchemasToStrictFromOpts,
  //     runContext: runContextFromOpts,
  //     agent: agentFromOpts,
  //     generateMCPToolCacheKey,
  //   });
  //   const serverToolNames = new Set(serverTools.map((t) => t.name));
  //   const intersection = [...serverToolNames].filter((n) => toolNames.has(n));
  //   if (intersection.length > 0) {
  //     throw new UserError(
  //       `Duplicate tool names found across MCP servers: ${intersection.join(", ")}`,
  //     );
  //   }
  //   for (const t of serverTools) {
  //     toolNames.add(t.name);
  //     allTools.push(t);
  //   }
  // }
  // return allTools;
}
